import React from 'react'
import { arrayOf, object } from 'prop-types'

import Container from 'components/atoms/Container'
import ProfessionSalaryItem from 'components/atoms/ProfessionSalaryItem'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'
import ThumbnailSlider from 'components/molecules/ThumbnailSlider'
import CampusPerfectCard from 'components/organisms/CampusPerfectCard'

import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config
const aptReportAssetsPath = `${assetsUrl}/assets/img/aptitude/report`

const AptitudeCareer = ({ careers }) => (
  <div className="aptitude-career">
    <SectionContainer
      paddingTop={120}
      backgroundColor="transparent"
    >
      <Container className="aptitude-report__title">
        <Relazsizes
          dataSrc={`${assetsUrl}/assets/img/aptitude/report/career.png`}
          alt="Karir"
        />
        <div>
          <Typography component="h2" variant="title" className="text-variant-title-sm m-b-sm">KARIER apa saja yang sesuai dengan kepribadianmu?</Typography>
          <Typography component="p" variant="subbody">Berikut adalah 10 rekomendasi karier yang bisa kamu pilih berdasarkan hasil tes yang telah kamu lakukan:</Typography>
        </div>
      </Container>
      <ThumbnailSlider>
        {
          careers && careers.map((career, idx) => (
            <div key={career.id} className="col-md-4 col-sm-6 col-xs-12">
              <CampusPerfectCard
                dataTestId={`rec-career-card-${idx}`}
                category={career.fieldName}
                description={career.description}
                href={career.path}
                kind="professions"
                likeable
                likeStatus={career.liked}
                likeTarget={career.id}
                icon={career.iconName}
                title={career.name}
                thumbnail={career.thumbnail}
                openNewTab
                withFooter
                footerContent={
                  !!(career.min_salary || career.max_salary) &&
                  <ProfessionSalaryItem
                    minSalary={career.min_salary}
                    maxSalary={career.max_salary}
                  />
                }
              />
            </div>
          ))
        }
      </ThumbnailSlider>
      <Container>
        <Typography component="p" variant="caption" className="text-center">Cari tahu informasi mengenai karier tersebut secara lebih mendalam di halaman <a href="/careers" target="_blank"><b>campus.quipper.com/careers</b></a>. Di sini, kamu bisa mendapatkan gambaran karier, rentang penghasilan, peran dan tanggung jawab, pengetahuan dan keahlian yang dibutuhkan, jenjang karier, minimum jenjang pendidikan, sertifikasi yang dibutuhkan, jurusan terkait, kampus rekomendasi, hingga cerita inspiratif dan informasi penting lainnya.</Typography>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
       .aptitude-career {
        background-image: url(${aptReportAssetsPath}/path-blue.png);
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        :global(.ThumbnailSlider) {
          margin: 0;
        }
        :global(p) {
          color: #0c2846 !important;
        }
        @media screen and (max-width: 767px) {
          background-size: cover;
          padding-top: 80px;
        }
      }
      `}
    </style>
  </div>
)

AptitudeCareer.propTypes = {
  careers: arrayOf(object),
}

export default AptitudeCareer
